/* eslint-disable no-undef */
/* eslint-disable max-len */
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Redirect,
  Switch,
  Route,
  BrowserRouter,
  useLocation,
} from 'react-router-dom';
import { App } from 'services/action';
import { Layout } from 'ui/components';
import _ from 'underscore';
import { fetchToken, onMessageListener } from 'utilities/firebase';
import { Notification } from 'services/action';
import { toast } from 'react-toastify';
import { FaRegBell } from 'react-icons/fa';

// Read subrouter in each subfolder
let routes = [];
const rf = require.context('./', true, /^.*_subrouter.js$/);
rf.keys().forEach((fileName) => {
  routes = routes.concat(rf(fileName).default);
});

const ListenPathChanged = () => {
  const { pathname } = useLocation();
  const Dispatch = useDispatch();

  React.useEffect(() => {
    Dispatch(App.$routeChanged(pathname));
  }, [pathname]);

  return null;
};

const ListenPushNotification = () => {
  const Dispatch = useDispatch();

  const $handleToken = (token) => {
    const payload = {
      app: 'tms',
      token: token,
    };

    Dispatch(Notification.$setDevice(payload));
  };

  React.useEffect(() => {
    fetchToken($handleToken);
  }, []);

  onMessageListener()
    .then((payload) => {
      // need to fetch the notification data
      Dispatch(Notification.$get());

      toast.success(
        <div className="notify">
          <h5>{payload?.notification?.title}</h5>
          <p>{payload?.notification?.body}</p>
        </div>,
        {
          position: 'bottom-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          icon: <FaRegBell color="#FFFFFFF" size={50} />,
          theme: 'colored',
        }
      );
    })
    .catch((err) => console.log('failed: ', err));

  return null;
};

const AuthorizedRouter = () => {
  const session = useSelector((state) => state?.Auth?.session);
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split('/');

  const getRedirect = () => {
    let redirect = <Redirect exact from="/*" to="/" />;

    let delivery = _.findWhere(session?.privileges, {
      module: 'delivery',
    });
    let contract = _.findWhere(session?.privileges, {
      module: 'contract',
    });
    let client = _.findWhere(session?.privileges, {
      module: 'client',
    });
    let manifest = _.findWhere(session?.privileges, {
      module: 'manifest',
    });
    let service = _.findWhere(session?.privileges, {
      module: 'service',
    });
    let pricing = _.findWhere(session?.privileges, {
      module: 'pricing',
    });
    let hub = _.findWhere(session?.privileges, {
      module: 'hub location',
    });
    let location = _.findWhere(session?.privileges, {
      module: 'location',
    });
    let driver = _.findWhere(session?.privileges, {
      module: 'driver',
    });
    let user = _.findWhere(session?.privileges, {
      module: 'user',
    });
    let usergroup = _.findWhere(session?.privileges, {
      module: 'usergroup',
    });
    let customer = _.findWhere(session?.privileges, {
      module: 'customer',
    });
    let vendor = _.findWhere(session?.privileges, {
      module: 'vendor',
    });

    if (delivery || manifest) {
      redirect = <Redirect exact from="/*" to="/" />;
    } else if (contract) {
      redirect = <Redirect exact from="/*" to="/order/contract" />;
    } else if (customer) {
      redirect = <Redirect exact from="/*" to="/master/customer" />;
    } else if (location) {
      redirect = <Redirect exact from="/*" to="/master/location" />;
    } else if (driver) {
      redirect = <Redirect exact from="/*" to="/master/driver" />;
    } else if (vendor) {
      redirect = <Redirect exact from="/*" to="/master/vendor" />;
    } else if (client) {
      redirect = <Redirect exact from="/*" to="/setting" />;
    } else if (service) {
      redirect = <Redirect exact from="/*" to="/setting/service" />;
    } else if (pricing) {
      redirect = <Redirect exact from="/*" to="/setting/pricing" />;
    } else if (hub) {
      redirect = <Redirect exact from="/*" to="/setting/hub" />;
    } else if (usergroup) {
      redirect = <Redirect exact from="/*" to="/setting/usergroup" />;
    } else if (user) {
      redirect = <Redirect exact from="/*" to="/setting/user" />;
    }

    return redirect;
  };

  return (
    <BrowserRouter>
      <Layout>
        {splitLocation[1] === 'print' ? null : (
          <Layout.Header sticky fluid consended />
        )}
        <Layout.Body>
          <ListenPushNotification />
          <ListenPathChanged />
          <Switch>
            {routes.map((d, i) => {
              let comp = null;

              if (session?.privileges) {
                let newRoute = [];

                d?.service?.forEach((g) => {
                  let find = _.findWhere(session?.privileges, { service: g });
                  if (find) {
                    newRoute?.push(d);
                  }
                });

                if (d?.path === '/profile/setting') {
                  comp = (
                    <Route
                      key={i}
                      exact
                      path={d.path}
                      component={d.component}
                    />
                  );
                }

                if (newRoute?.length > 0) {
                  newRoute?.forEach((r) => {
                    comp = (
                      <Route
                        key={i}
                        exact
                        path={r.path}
                        component={r.component}
                      />
                    );
                  });
                }
              } else {
                comp = (
                  <Route key={i} exact path={d.path} component={d.component} />
                );
              }

              return comp;
            })}

            {getRedirect()}
          </Switch>
        </Layout.Body>
      </Layout>
    </BrowserRouter>
  );
};

export default AuthorizedRouter;
